export default __webpack_public_path__ + "static/crumble-6e5d7dfe036727ae80df7eedf3e12c47.png";